import "./Footer.css";

function Footer() {
  return (
    <div className="Footer">
      <h5>contact: 1(823)454-9877</h5>
      <h5>About Us</h5>
    </div>
  );
}

export default Footer;
